import api from './api';

export const getTrainers         = (params)            => api.get('/api/trainers', { params });
export const getMyTrainerProfile = ()                  => api.get('/api/trainers/me');
export const createTrainer       = (data)              => api.post('/api/trainers', data);
export const updateTrainerStatus = (id, isActive)      => api.put(`/api/trainers/${id}/status`, { isActive });
export const directAddTrainer    = (data)              => api.post('/api/trainers/direct-add', data);
export const getTrainerById      = (id)               => api.get(`/api/trainers/${id}`);
export const updateTrainer       = (id, data)         => api.patch(`/api/trainers/${id}`, data);
export const updateTrainerNotes  = (id, notes)        => api.patch(`/api/trainers/${id}/notes`, { notes });
export const updateTrainerSalary = (id, data)         => api.patch(`/api/trainers/${id}/salary`, data);
export const deleteTrainer       = (id)               => api.delete(`/api/trainers/${id}`);
